import { useQueryData } from "@src/hooks/useQueryData";
import { boOperationsApi } from "./operations/api.core";
import type { ApiOmpBoAvOperation } from "./operations/types";

/**
 * Доступные операции над БО для текущего пользователя и статуса.
 */
export function useBoAvOperations(boCode: number | null | undefined, enabled = true) {
    const safeBoCode = boCode != null && boCode > 0 ? boCode : 0;

    return useQueryData<ApiOmpBoAvOperation[]>({
        queryKey: ["boAvOperations", safeBoCode],
        queryFn: () => boOperationsApi.loadAvailable({ boCode: safeBoCode }),
        enabled: enabled && safeBoCode > 0,
    });
}
